import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor() { }

  dateToStringBr(date) {
    const data = new Date(date);
    const dateBr = ('0' + data.getDate()).slice(-2) + '/' +
    ('0' + (data.getMonth() + 1 ) ).slice(-2) + '/' +
    data.getFullYear();
    return dateBr;
  }

  dateToDataBaseString(date) {
    const data = new Date(date);
    const dateDb = data.getFullYear() + '-' +
    ('0' + (data.getMonth() + 1 ) ).slice(-2) + '-' +
    ('0' + data.getDate()).slice(-2);
    return dateDb;
  }

  capitalize(myString: string) {
    return myString.charAt(0).toUpperCase() + myString.slice(1);
  }

}
